export const postalShippingOptions = {
  NONE: 'Nur online als Pdf - kein Postversand',
  AUTOMATIC: 'Automatischer Druck und Postversand',
  MANUAL: 'Selbst organisierter Versand'
}
